module.exports = __webpack_public_path__ + "static/media/valleaunknown.04c5479d.svg";